<template>
  <Slide right>
    <h2>{{ currentPage }}</h2>
  </Slide>
</template>

<script>
import { Slide } from 'vue-burger-menu'
export default {

  name: 'Menu',

  data () {
    return {
      currentPage: this.$route.name
    }
  },
  components: {
    Slide
  },
  props: {
  }
}
</script>

<style lang="css" scoped>
</style>
